import { loginRoute } from "./login";
import { dashboardRoutes } from "./Topbar";

export const routes = {
    login: loginRoute,
    dashboard: dashboardRoutes
};